/** «0:07», «1:05»: la duración de una nota de voz; `null` si no se conoce. */
export function formatVoiceDuration(seconds: number | undefined): string | null {
  const value = seconds ?? Number.NaN
  if (!Number.isFinite(value)) return null
  const total = Math.max(1, Math.round(value))
  const minutes = Math.floor(total / 60)
  return `${minutes}:${String(total % 60).padStart(2, '0')}`
}

/** «0:00», «0:03»: por dónde va la voz que suena (sin el mínimo de 1 s de la duración). */
export function formatPlaybackPosition(seconds: number): string {
  const total = Number.isFinite(seconds) ? Math.max(0, Math.floor(seconds)) : 0
  return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, '0')}`
}
